import { Swiper, SwiperSlide } from 'swiper/react';
import "./slider.css";

export const Slider = ({ children, settings, className }) => {
    const sliderOptions = {
      slidesPerView: 1,
      pagination: true,
      navigation: false,
      loop: true,
      ...settings,
    };

    return (
      <div>
        <Swiper {...sliderOptions} className={className}>{children}</Swiper>
      </div>
    );
}

export { SwiperSlide as Slide };